<template>
    <nav id="colorlib-main-menu" role="navigation">
        <ul v-if="languageData && menuItems ">
            <li class="colorlib-active"><a href="/" v-html="languageData['d00']"></a></li>
            <li v-for="(men, key) in menuItems" :key="key">
                <!--<a href="../division/">{{languageData['d'+key.trim()]}}</a>-->
                <router-link :to="'/division/'+key.trim()" :key="key" v-html="languageData['d'+key.trim().toString()]"></router-link>
            </li>
            <li>
                <a v-on:click.stop.prevent="openNewWindow('https://rms.workplaceoptions.com/anonymouschat/D509C30F-7FB2-431F-8646-8CBD8F945634/94026cbd-ef16-4a44-a88b-1dbe0764ece7/00000000-0000-0000-0000-000000000000/11e7a159-e5e5-4fe2-a57f-f8567597ecd3?id_company=99924272&amp;name_company=WPO Employees')" href="" >Live Connect</a>    
            </li>
            <!--
            <li><a href="fashion.html">Fashion</a></li>
            <li><a href="travel.html">Travel</a></li>
            <li><a href="sports.html">Sports</a></li>
            <li><a href="video.html">Video</a></li>
            <li><a href="archives.html">Archives</a></li>-->
        </ul>      
        <div v-else @click="showMenu()">
            loading...
        </div>

        <!--<ul v-if="menuItems">
          <li><a href="">Test Link</a></li>
          
        </ul>-->
    </nav>

</template>

<script>

    export default{
        name:'MainMenuPages',

        computed:{
            menuItems(){
                //console.log(this.$store.state.menuVar);
                return this.$store.state.menuVar;
                },
            languageData(){return this.$store.state.languageData;}
        },

        components: {
        
        },  
          
        mounted:function(){
            this.showMenu()
        },
        methods: {
            showMenu(){
                this.$store.dispatch('getMenu');
                //console.log('homeContent'+state.content);
            }
        }
    }; 
</script>

<style scoped>

a.router-link-exact-active.router-link-active{
    color: #000;
    visibility: visible;
    -webkit-transform: scaleX(1);
    -moz-transform: scaleX(1);
    -ms-transform: scaleX(1);
    -o-transform: scaleX(1);
    transform: scaleX(1); 
}
</style>
